import { render, staticRenderFns } from "./AttendanceChatTransfer.vue?vue&type=template&id=7431e532&scoped=true"
import script from "./AttendanceChatTransfer.vue?vue&type=script&lang=js"
export * from "./AttendanceChatTransfer.vue?vue&type=script&lang=js"
import style0 from "./AttendanceChatTransfer.vue?vue&type=style&index=0&id=7431e532&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7431e532",
  null
  
)

export default component.exports
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCheckbox,QSpinnerDots,QIcon,QItemLabel,QTooltip});
